<template>

  <div class="rows">
    <div class="container">
      <div class="col-xs-3">
        <label for="dateCreation">
          Date de création
        </label>
        <treeselect class="tree-select" v-if="demandes.availableDates"
                  ref="treeDates"
                  :multiple="true"
                  v-model="demandes.filters.daysList"
                  :searchable="true"
                  :options="demandes.availableDates"
                  sortValueBy="LEVEL"
                  :default-expand-level="1"
                  :limit="3"
                  :limitText="count => `et ${count} de plus`"
                  :max-height="300"
                  placeholder="Date sélectionnées"
                  :allways-opened="false"
                  :disable-branch-nodes="true"
                  v-on:change="reloadDemandes()"
                  @input="reloadDemandes">
        </treeselect>
      </div>
      <div class="col-xs-3">
        <label for="cantonniers">
          Cantonniers
        </label>
        <treeselect class="tree-select" v-if="demandes.availablesCantonniers"
                  ref="treeCanto"
                  :multiple="true"
                  v-model="demandes.filters.idCantonniers"
                  :searchable="true"
                  :options="demandes.availablesCantonniers"
                  sortValueBy="LEVEL"
                  :default-expand-level="1"
                  :limit="3"
                  :limitText="count => `et ${count} de plus`"
                  :max-height="300"
                  placeholder="Cantonniers sélectionnés"
                  :allways-opened="false"
                  :disable-branch-nodes="true"
                  v-on:change="reloadDemandes()"
                  @input="reloadDemandes">
        </treeselect>
      </div>
      <div class="col-xs-3">
        <label for="statut">
          Statut
        </label>
        <select v-model="demandes.filters.selectedStatus" class="form-control demande-filters" id="statut" v-on:change="reloadDemandes()">
          <option value="1">Sélectionner un statut</option>
          <option v-for="statut in demandes.status" v-bind:value="statut" v-bind:item="demandes.filters.selectedStatut" v-bind:key="statut">
              {{ statut }}
          </option>
        </select>
      </div>
    </div>

    <br>

    <transition-group name="fade">
    <div class="row" v-for="demande in demandes.filtredDemandes" :key="demande.id" >
      <div class="col-xs-2">
        <span class="title-item">Maitrise</span>
        <span class="text-item">{{demande.maitrise_id | maitriseName}}</span>
      </div>
      <div class="col-xs-2">
        <span class="title-item">Cantonnier</span>
        <span class="text-item">{{demande.cantonnier_id | cantonnierName}}</span>
      </div>
      <div class="col-xs-2">
        <span class="title-item">Statut de la demande</span>
        <span class="text-item">{{demande.statusDemande}}</span>
      </div>
      <div class="col-xs-2">
        <span class="title-item">Priorité</span>
        <span class="text-item">{{formatPriorite(demande.priority)}}</span>
      </div>
      <div class="col-xs-2">
        <span class="title-item">Heure de création</span>
        <span class="text-item">{{formatDate(demande.createdAt)}}</span>
      </div>
      <div class="col-xs-2">
        <div class="actions">
          <a class="action-edit" v-on:click="$emit('edit', demande)">
            <img src="../../../../static/img/edit-icon.svg">
          </a>
          <a class="action-delete right-separator" v-on:click="$emit('delete', demande)">
            <img src="../../../../static/img/delete-icon.svg">
          </a>
        </div>
      </div>
    </div>
     </transition-group>
  </div>

</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
import Treeselect from '@riophae/vue-treeselect'
import * as demandeStatut from './../../../utils/demandeStatut'
import * as _ from 'lodash'
import state from '../../../store/state'

export default {
  components: {Treeselect},
  computed: {
    ...mapState([
      'demandes',
      'cantonniers',
    ]),
  },
  mounted: async function () {

    await this.$store.dispatch('fetchAllCantonniersOfVille')
    this.$store.dispatch('fetchAllMaitrises')
    await this.$store.dispatch('fetchDemandesByVilleId')
   // this.reloadDemandes()
  },
  methods: {
    formatDate: function (date) {
      return moment(date).format('DD/MM/YYYY HH:mm')
    },
    formatPriorite: function (priorite) {
      switch (priorite) {
        case "1" : return 'Très urgente'
        case "2" : return 'Urgente'
        case "3" : return 'Peu urgente'
      }
    },
    reloadDemandes: async function () {
      await this.$store.dispatch('fetchDemandesByVilleId')
      this.$store.dispatch('reloadDemandes')
/*       //  state.demandes.filters.selectedStatus = this.selectedStatut
      let $this = this
      // // Demandes filtred by status
      if (state.demandes.filters.selectedStatus !== '1') {
        this.demandes.filtredDemandes = _.filter(this.demandes.data, function (demande) {
          console.log('demande type ,', typeof demande.statusDemande)
          return demande.statusDemande === state.demandes.filters.selectedStatus
        })
      } else {
        this.demandes.filtredDemandes = this.demandes.data
      }
      // // Demandes filtred by Canto
      if (this.demandes.filters.idCantonniers.length > 0) {
        this.demandes.filtredDemandes = _.filter(this.demandes.filtredDemandes, function (demande) {
          return _.find($this.demandes.filters.idCantonniers, function (canto) {
            // console.log(canto)
            return demande.cantonnier_id === canto
          })
        })
      } else {
        this.demandes.availablesCantonniers = _.cloneDeep(this.demandes.initialCantonniers)
      }
      // Demandes filtred by dates
      if (this.demandes.filters.daysList.length > 0) {
        this.demandes.filtredDemandes = _.filter(this.demandes.filtredDemandes, function (demande) {
          return _.find($this.demandes.filters.daysList, function (day) {
            return demande.day === day
          })
        })
      } else {
        this.demandes.availableDates = _.cloneDeep(this.demandes.initialDates)
      }
      this.$store.dispatch('updateDemandesCantoFilter') */
    },
  },
}
</script>

<style lang="scss">
@import '../../../scss/variables';

.action-delete .tooltiptext {
  visibility: hidden;
  width: 210px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
}

.action-delete:hover .tooltiptext {
  visibility: visible;
}

.action-edit .tooltiptext {
  visibility: hidden;
  width: 210px;
  background-color: black;
  color: #fff;
  text-align: left;
  border-radius: 6px;
  padding-left: 20px;
  right: 50%;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
}

.action-edit:hover .tooltiptext {
  visibility: visible;
}

.demande-filters {
  background-color: $suez-green-yellowish;
  color: $suez-blue;
  border: none;
  font: 14px/22px 'DinMedium';
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0.3;
}
</style>



// WEBPACK FOOTER //
// DemandesList.vue?e7d11334